import videosData from './analytics-cup-26-videos.json';

const normalize = name => name.toLowerCase().replace(/[_\s]+/g, '');

const lookup = Object.fromEntries(
    (videosData.videos || []).map(v => [normalize(v.nameKey), v])
);

export const findVideo = name => (name ? lookup[normalize(name)] : null) || null;

export const youtubeUrl = youtubeId =>
    `https://www.youtube.com/watch?v=${youtubeId}`;
